import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import ButtonsGroup from '../../../ui/ButtonsGroup';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import { setRallyToDeactivateId } from '../../../store/adminSlices/rallies';
const DeactivateRally = ({ rallyId }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    return (_jsxs("div", { className: 'modal-content deactivate-rally', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('admin.deactivate_rally'), type: 'h1' }) }), _jsx("div", { className: "modal-content-button", children: _jsxs(ButtonsGroup, { justify: 'center', children: [_jsx(Button, { label: t('button.cancel'), onClick: () => {
                                dispatch(setIsModalOpen(false));
                                dispatch(setModalContent(null));
                            }, tabIndex: 1 }), _jsx(Button, { variant: 'outlined', label: t('button.deactivate'), onClick: () => {
                                dispatch(setRallyToDeactivateId(rallyId));
                                dispatch(setIsModalOpen(false));
                                dispatch(setModalContent(null));
                            }, tabIndex: 1 })] }) })] }));
};
export default DeactivateRally;
